export const PROVIDER_COVER_GENIUS = 'cover_genius'
export const PROVIDER_NIB = 'nib'

export const PRODUCT_ID_COMPREHENSIVE = 'COMPREHENSIVE_TRIP_PROTECTION'
export const PRODUCT_ID_OVERSEA_MEDICAL = 'OVERSEAS_MEDICAL_AND_EVACUATION_PROTECTION'
export const PRODUCT_ID_CANCELLATION_AND_BAGGAGE = 'CANCELLATION_AND_BAGGAGE_PROTECTION'
export const PRODUCT_ID_NO_PROTECTION = 'NO_PROTECTION'
export const PRODUCT_ID_FULL_PROTECTION_CRUISE_DOMESTIC = 'FULL_PROTECTION_CRUISE_DOMESTIC'
export const PRODUCT_ID_FULL_PROTECTION_CRUISE = 'FULL_PROTECTION_CRUISE'
export const PRODUCT_ID_CUSTOMISE = 'CUSTOMISE_PROTECTION'
export const PRODUCT_ID_CUSTOMISE_DOMESTIC = 'CUSTOMISE_PROTECTION_DOMESTIC'
export const PRODUCT_ID_PASSPORT_CARD = 'PASSPORT_CARD_COMPREHENSIVE_TRAVEL_INSURANCE'
export const INSURANCE_TYPE_PASSPORT_CARD: App.InsuranceType = 'passport-card-insurance'

export const POLICY_ID_TRAVEL_MEDICAL_COVER: App.InsurancePolicyId = 'travel_medical_cover'
export const POLICY_ID_TRAVEL_PERSONAL_BAGGAGE: App.InsurancePolicyId = 'travel_personal_baggage'

/** These insurance product ids are used for the 'customised' options  */
export const CustomisableProductIds = new Set([PRODUCT_ID_CUSTOMISE, PRODUCT_ID_CUSTOMISE_DOMESTIC])

export const INSURANCE_CANCELLATION_REASON_UPGRADED = 'insurance_upgraded'

export const CRUISE_INSURANCE_LIMIT_AGE = 80

export const CUSTOM_AMOUNT_COVERAGE_OPTIONS = [1000, 2000, 3000, 4000, 5000, 6000, 7000, 8000, 9000, 10000, 20000, 30000, 40000, 50000, 60000, 70000, 80000, 90000, 100000]

export const INSURANCE_PRODUCT_ID = {
  CFMR: 'CFMR',
} as const

export const INSURANCE_PRODUCT_TYPE = {
  BOOKING_PROTECTION: 'booking-protection',
  INSURANCE: 'travel-insurance',
} as const
